import React, { useRef } from 'react'
import PropTypes from 'prop-types'
import { Field, getIn } from 'formik'
import classNames from 'classnames'
import axios from 'axios'
import { toast } from 'react-toastify'
import { useConfig } from '@peracto/peracto-config'

import { FormGroup } from '@peracto/peracto-ui'

const File = ({
    name,
    label = '',
    help,
    className,
    showWhen,
    required = null,
    defaultValue,
    onSelectCallback = null,
    showThumbnail = false,
    testId,
    disabled,
    ...props
}) => {
    const config = useConfig()
    const API_URL = config.get('api')
    const { uploads } = config.get('features', {})

    const inputFile = useRef(null)

    const token = window.localStorage.getItem('token')

    const switchLocatioName = name => {
        switch (name) {
            case 'location_image_input':
                return 'locations'
            case 'resources_Main Image':
                return 'categories'
            case 'resources_Secondary Image':
                return 'categories'
            case 'resources_Image':
                return 'product_image'
            case 'resources_Document':
                return 'product_file'
            case 'resources_Silo':
                return 'product_image'
            case 'icon':
                return 'product_attribute'
        }
        return undefined
    }
    const getlocation = name => {
        switch (name) {
            case 'product_image':
                return '/images/products/'
            case 'product_file':
                return '/files/products/'
            case 'product_attribute':
                return '/images/attributes/'
            case 'categories':
                return '/images/categories/'
            case 'content':
                return '/images/content/'
            case 'locations':
                return '/images/locations/'
        }
        return undefined
    }

    const acceptedFiles = ['pdf', 'txt', 'png', 'jpg', 'jpeg']

    const getAssetUrl = async (file, form, field) => {
        const extension = file?.name.split('.')[1]

        if (acceptedFiles.filter(file => file === extension)) {
            const switchedName = switchLocatioName(name)
            const location = getlocation(switchedName)

            const payload = {
                type: switchedName,
                filename: file?.name.split('.')[0],
                extension: extension,
            }

            try {
                const res = await axios.post(`${API_URL}/uploads`, payload, {
                    headers: {
                        Authorization: `Bearer ${localStorage.getItem('token')}`,
                    },
                })

                try {
                    await axios.put(res.data.assetUrl, file, {
                        headers: { 'Content-Type': file.type || 'application/octet-stream' },
                    })

                    if (typeof onSelectCallback === 'function') {
                        onSelectCallback(
                            `${process.env.REACT_APP_ASSETS_URL}${location}${file?.name}`
                        )
                    } else {
                        form.setFieldValue(
                            field.name,
                            `${process.env.REACT_APP_ASSETS_URL}${location}${file?.name}`
                        )
                    }

                    const files = document.querySelectorAll('[id=file]')
                    files.forEach(file => (file.value = ''))
                } catch (e) {
                    console.error(e)
                    toast.error(
                        e?.error?.body?.hasOwnProperty('hydra:description')
                            ? e.error.body['hydra:description']
                            : 'Whoops, there was a problem...'
                    )
                }
            } catch (e) {
                console.error(e)
                toast.error(
                    e?.error?.body?.hasOwnProperty('hydra:description')
                        ? e.error.body['hydra:description']
                        : 'Whoops, there was a problem...'
                )
            }
        } else {
            console.error('Invalid file type')
            toast.error('Invalid file type')
            return
        }
    }

    return (
        <Field name={name}>
            {({ field, form }) => {
                let error = getIn(form.errors, name)

                if (error) {
                    const errorFieldName = label ? label : 'This'
                    error = error.replace(field.name, errorFieldName)
                }

                if (showWhen) {
                    const showField = form.values.hasOwnProperty(showWhen)
                        ? form.values[showWhen]
                        : false

                    if (!showField) {
                        return null
                    }
                }

                props.className = classNames('form-control', className)

                if (help) props['aria-describedby'] = `${name}Help`

                if (!field.value) {
                    if (defaultValue) {
                        field.value = form.setFieldValue(field.name, defaultValue)
                    } else {
                        field.value = ''
                    }
                }

                return (
                    <FormGroup {...{ name, label, help, required }} error={error}>
                        <div className="input-group">
                            <input
                                type="text"
                                {...field}
                                {...props}
                                disabled={form.isSubmitting || disabled}
                                data-testid={testId}
                                style={{
                                    paddingRight: '80px',
                                }}
                            />

                            {uploads?.CKEditorBypass && (
                                <>
                                    <input
                                        type="file"
                                        id="file"
                                        ref={inputFile}
                                        onChange={async event => {
                                            await getAssetUrl(event.target.files[0], form, field)
                                        }}
                                        style={{ display: 'none' }}
                                    />
                                    <button
                                        className={'btn btn-secondary !ml-2'}
                                        style={{
                                            position: 'absolute',
                                            right: 77,
                                            top: 0,
                                            bottom: 0,
                                            zIndex: 10,
                                        }}
                                        disabled={disabled}
                                        data-testid={`button-${name.replaceAll(' ', '-')}`}
                                        onClick={e => {
                                            e.preventDefault()
                                            inputFile.current.click()
                                        }}
                                    >
                                        Upload
                                    </button>
                                </>
                            )}

                            <button
                                className={'btn btn-primary !ml-2'}
                                style={{
                                    position: 'absolute',
                                    right: 0,
                                    top: 0,
                                    bottom: 0,
                                    zIndex: 10,
                                }}
                                disabled={disabled}
                                data-testid={`button-${name.replaceAll(' ', '-')}`}
                                onClick={e => {
                                    e.preventDefault()
                                    if (window?.CKFinder && !disabled) {
                                        window.CKFinder.modal({
                                            chooseFiles: true,
                                            displayFoldersPanel: false,
                                            removeModules: 'Maximize,EditImage',
                                            pass: 'token',
                                            token: token,
                                            width: 800,
                                            height: 600,
                                            onInit: function(finder) {
                                                finder.on('files:choose', function(evt) {
                                                    var file = evt.data.files.first()
                                                    if (typeof onSelectCallback === 'function') {
                                                        onSelectCallback(file.getUrl())
                                                    } else {
                                                        form.setFieldValue(
                                                            field.name,
                                                            file.getUrl()
                                                        )
                                                    }
                                                })

                                                finder.on('file:choose:resizedImage', e => {
                                                    if (typeof onSelectCallback === 'function') {
                                                        onSelectCallback(e.data.resizedUrl)
                                                    } else {
                                                        form.setFieldValue(
                                                            field.name,
                                                            e.data.resizedUrl
                                                        )
                                                    }
                                                })
                                            },
                                        })

                                        return false
                                    }
                                }}
                            >
                                Browse
                            </button>
                        </div>
                    </FormGroup>
                )
            }}
        </Field>
    )
}

File.displayName = 'File'

File.propTypes = {
    name: PropTypes.string.isRequired,
    label: PropTypes.string,
    help: PropTypes.oneOfType([PropTypes.string, PropTypes.func]),
    placeholder: PropTypes.string,
    className: PropTypes.string,
    showWhen: PropTypes.string,
    onSelectCallback: PropTypes.func,
}

export default File
